const getters = {
    locationDescription: state => state.locationDescription,
    locationImage: state => state.locationImage,
    searchQueryLocation: state => state.searchQueryLocation,
};

export default getters;